module.exports = __webpack_public_path__ + "static/iso9001-9a9933d07dc6139e4e3bcbe113529e51.svg";